import { render, staticRenderFns } from "./DispensationEscalationFile.vue?vue&type=template&id=46a16e12&scoped=true&"
import script from "./DispensationEscalationFile.vue?vue&type=script&lang=js&"
export * from "./DispensationEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./DispensationEscalationFile.vue?vue&type=style&index=0&id=46a16e12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a16e12",
  null
  
)

export default component.exports